<template>
  <div>
    <div class="cs-university-labelContainer">
      <span class="cs-university-label" v-for="item in universityList" :key="item.Key">{{ item.Value }}:{{
        item.Key
      }}</span>
    </div>
    <div :class="{'cs-discountList-filter': true, 'margin-top-10': accountType === 1 || accountType === 2}">
      <el-row>
        <el-col :span="4" v-if="accountType === 1 || accountType === 2">
          <el-select class="cs-discountList-term" @change="search" placeholder="学期" v-model="selectedTermId" size="medium">
            <el-option label="所有学期" value=""></el-option>
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="4">
          <el-select @change="search()" placeholder="请选择" size="medium" v-model="selectedGroupNumber"
            class="margin-left-20px">
            <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue"
              :value="item.GroupNumber"></el-option>
          </el-select>
        </el-col> -->
        <el-col :span="4">
          <el-checkbox class="cs-discountList-showAll" v-model="showAllFormulas" @change="onShowAllFormulasChange">显示所有公式</el-checkbox>
        </el-col>
        <el-col :span="spanBtnContainer" class="cs-discountList-filter-right">
          <el-button class="cs-discountList-add" type="primary" plain icon="el-icon-plus"
            @click="add">添加</el-button>
          <el-input class="cs-discountList-search" placeholder="搜索" size="medium" clearable
            suffix-icon="el-icon-search" v-model.trim="searchKeyword" @change="search" @keyup.enter.native="search">
          </el-input>
        </el-col>
      </el-row>
    </div>
    <pagination v-loading="loading" :data="listData" @loadData="onListDataLoad" :option="paginationOption"
      @enableChange="onEnableChange" @search="onSearch" @add="add" @edit="edit" @delete="onDelete"
      @additionalBtnClick="onAdditionalBtnClick" @additional="onAdditional"></pagination>
    <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
      <formulaEdit :termList="termList" :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess">
      </formulaEdit>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-university-labelContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.cs-university-label {
  display: block;
  margin-right: 1rem;
}

.cs-discountList-filter{
  .cs-discountList-term{

  }
  .cs-discountList-showAll{
    display: inline-block;
    line-height: 36px;
    margin-left: 10px;
  }
  .cs-discountList-filter-right{
    text-align: right;
  }
  .cs-discountList-add{
    margin-right: 10px;
    display: inline-block;
  }
  .cs-discountList-search{
    max-width: 200px;
    display: inline-block;
  }
}
</style>

<script>
import pagination from "../common/pagination";
import formulaEdit from "./formulaEdit";
import {
  getFormulaList,
  deleteFormula,
  changeFormulaEnable
} from "../../service/finance.service";

export default {
  props: {
    isActive: Boolean,
    accountType: Number,
    universityList: Array,
    universityGroups: Array,
    termList: Array,
  },
  data() {
    return {
      loading: false,
      listAllData: {},
      listData: {},
      paginationOption: {},
      editData: {},
      editIndex: -1,
      dialogEditorVisible: false,
      searchKeyword: "",
      pageSize: 20,
      selectedTermId: "",
      selectedGroupNumber: "",
      showAllFormulas: false,
      isLoadedData: false,
      spanBtnContainer: 16,
    };
  },
  components: {
    pagination,
    formulaEdit
  },
  created() {
    if (this.accountType === 1 || this.accountType === 2){
      this.spanBtnContainer = 16;
    }else{
      this.spanBtnContainer = 20;
    }
    let additionalColumns = [];
    additionalColumns.push({
      name: 'copy',
      title: '',
      buttonText: '复制',
      fnVisible: this.getCopyBtnVisible
    });
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      editButtonText: "编辑",
      hasAddButton: false,
      addButtonText: "添加",
      hasDeleteButton: false,
      hasSearch: false,
      hasEnableButton: true,
      hasAdditionalButton: false,
      additionalButtonText: "测试公式",
      additionalColumns: additionalColumns
    };

    if (this.isActive) {
      this.search();
    }

  },
  methods: {
    getCopyBtnVisible(index, row) {
      if (row.FormulaType === 1) {
        return true;
      } else {
        return false;
      }
    },
    onAdditionalBtnClick() {

    },
    onEnableChange(index, row) {
      changeFormulaEnable(row.Id).then(result => {
        if (result.success) {
          let isEnable = row.Enable;
          let msg = "停用";
          if (!isEnable) {
            msg = "启用";
          }

          this.$message.success(msg + "公式成功!");
          this.$set(row, "Enable", !isEnable);
        } else {
          this.$message.error(result.message);
        }
      });
    },
    onDelete(index, row) {
      if (!!row) {
        if (row.FormulaType == 2) {
          this.$message.warning("系统预置变量不允许删除!");
          return;
        }

        let title = "优惠政策";
        if (row.FormulaType == 2) {
          title = "自定义变量";
        }
        this.$confirm("您确定要删除该条" + title + "?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (!row.Id) {
              this.deleteFormulaRow(index);
            } else {
              deleteFormula(row.Id).then(result => {
                if (result.success) {
                  this.deleteFormulaRow(index);
                } else {
                  this.$message.error(result.message);
                }
              });
            }
          })
          .catch(() => { });
      }
    },
    deleteFormulaRow(index) {
      if (index >= 0 && index < this.listData.Results.length) {
        this.$delete(this.listData.Results, index);
      }
    },
    onSearch(keyword) {
      this.searchKeyword = keyword;
      this.search();
    },
    onListDataLoad(pageData) {
      this.searchByPageNumber(pageData.pageNumber);
    },
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
    onSaveSuccess(isAdd, row) {
      this.dialogEditorVisible = false;
      let list = this.listData.Results;
      if (isAdd) {
        let lastIndex = list[list.length - 1].Index;
        row["Index"] = "";
        this.listData.Results.splice(0, 0, row);

        //this.$set(this.listData.Results, list.length, row);
      } else {
        let index = this.editData.Index;
        row["Index"] = index;
        this.$set(this.listData.Results, this.editIndex, row);
      }
    },
    search() {
      this.searchByPageNumber();
    },
    searchByPageNumber(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.getListData(pageData);
    },
    add() {
      this.editData = {
        Id: 0,
        FormulaType: 1,
        AccountType: this.accountType
      };
      this.dialogEditorVisible = true;
    },
    edit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        AccountType: this.accountType,
        TermId: this.selectedTermId
      };
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchKeyword,
        startDate: "",
        endDate: "",
        additionalFilter: additionalFilter
      };
      return pageData;
    },
    getListData(pageData) {
      this.loading = true;

      getFormulaList(pageData).then(result => {
        if (result && result.success) {
          this.listAllData = result.data;
          this.loadFormulaList();
        }

        this.loading = false;
        this.isLoadedData = true;
      });
    },
    onAdditional(name, index, row) {
      if (name == 'copy') {
        let rowData = JSON.parse(JSON.stringify(row));
        rowData.Id = 0;
        rowData.VariableName = rowData.VariableName + "_Copy";
        rowData.LabelName = rowData.LabelName + "_Copy";
        rowData.IsCopy = true;
        this.editData = rowData;
        this.dialogEditorVisible = true;
      }
    },
    loadFormulaList() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.listAllData));
      if (!this.showAllFormulas) {
        data.Results = data.Results.filter(i => i.FormulaType !== 2);
      }
      this.listData = data;
      this.loading = false;

    },
    onShowAllFormulasChange() {
      this.loadFormulaList();
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.search();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/discountList.vue